export const financeDashboardData = {
  kpis: {
    totalPayroll: "₹12,50,000",
    pendingPayroll: "₹2,35,000",
    expenseClaims: 18,
    travelRequests: 7,
    monthlyExpenses: "₹4,80,000",
    employeesPaid: 156,
  },

  payroll: {
    employeesPaid: 156,
    pendingPayroll: "₹2,35,000",
    nextPayrollDate: "31 Jul 2026",
    status: "Pending Approval",
  },

  expense: {
    pendingClaims: 18,
    approved: 124,
    rejected: 6,
    reimbursements: "₹1,82,000",
  },

  travel: {
    pendingTrips: 7,
    approvedTrips: 38,
    settledTrips: 31,
  },

  approvals: [],

  recentTransactions: [],
};